export const CANCEL_IMPORT = 'app/ImportStatus/CANCEL_IMPORT'
export const CANCEL_IMPORT_DONE = 'app/ImportStatus/CANCEL_IMPORT_DONE'
export const CANCEL_IMPORT_ERROR = 'app/ImportStatus/CANCEL_IMPORT_ERROR'
export const CANCEL_ALL_IMPORTS = 'app/ImportStatus/CANCEL_ALL_IMPORTS'
export const CANCEL_ALL_IMPORTS_DONE =
  'app/ImportStatus/CANCEL_ALL_IMPORTS_DONE'
export const CANCEL_ALL_IMPORTS_ERROR =
  'app/ImportStatus/CANCEL_ALL_IMPORTS_ERROR'
export const GET_UPLOAD_STATUS = 'app/ImportStatus/GET_UPLOAD_STATUS'
export const GET_UPLOAD_STATUS_DONE = 'app/ImportStatus/GET_UPLOAD_STATUS_DONE'
export const GET_UPLOAD_STATUS_ERROR =
  'app/ImportStatus/GET_UPLOAD_STATUS_ERROR'
export const HIDE_IMPORT = 'app/ImportStatus/HIDE_IMPORT'
export const HIDE_ALL_FINISHED_IMPORTS =
  'app/ImportStatus/HIDE_ALL_FINISHED_IMPORTS'
export const HIDE_ALL_FINISHED_EXPORTS =
  'app/ImportStatus/HIDE_ALL_FINISHED_EXPORTS'
export const CANCEL_ALL_EXPORTS = 'app/ImportStatus/CANCEL_ALL_EXPORTS'
export const SET_IMPORTS_AS_LOADED = 'app/ImportStatus/SET_IMPORTS_AS_LOADED'
export const SET_DOWNLOAD_STATUS = 'app/ImportStatus/SET_DOWNLOAD_STATUS'
export const REMOVE_DOWNLOAD_STATUS = 'app/ImportStatus/REMOVE_DOWNLOAD_STATUS'

export const stagesMessageMap = {
  UploadOriginal: 'planImport_uploadingOriginal',
  PdfConversion: 'planImport_pdfConversion',
  DownloadFromMapProvider: 'planImport_downloadFromMapProvider',
  CreatingThumbnail: 'planImport_creatingThumbnail',
  Tiling: 'planImport_tiling',
  Storing: 'planImport_storing',
  Publishing: 'planImport_publishing',
  Archiving: 'planImport_archiving',
  Succeeded: 'planImport_success',
  Failed: 'planImport_failed',
  CancelInProgress: 'planImport_cancelInProgress',
  Canceled: 'planImport_canceled',
  CancelFailed: 'planImport_cancelFailed',
}
